export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["注册信息"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已确认"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公开"])}
}